var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Scores")]),_c('ul',_vm._l((_vm.orderedScores),function(score,index){return _c('li',{key:index},[_c('span',[_vm._v("Score "+_vm._s(index + 1)+":")]),_vm._v(" "+_vm._s(score)+" points")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }